<!--
 * @Author: 孙照
 * @LastEditTime: 2023-02-03 18:44:47
 * @Description: soc 折线图
 * @FilePath: \dsnd_monitor\src\module\chargingProgressModal\components\socLineChart.vue
-->
<template>
  <div class="soc-line-chart">
    <pub-info-title :title="'SOC'" :is-modal="true" />
    <div class="chart-container">
      <pub-line-chart
      :xAxisData="xAxisData"
      :seriesData="seriesData"
      :extraOption="extraOption"
    />
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import pubInfoTitle from '@/components/infoTitle/index.vue';
import pubLineChart from '@/components/pubLineChart/index.vue';

export default {
  name: 'socLineChart',
  components: {
    pubInfoTitle,
    pubLineChart,
  },
  props: {
    xData: {
      type: Array,
      default: [],
    },
    socLsit: {
      type: Array,
      default: [],
    },
  },
  watch: {
    socLsit: {
      handler(val) {
        this.seriesData = val;
        this.xAxisData = this.xData;
      },
      deep: true,
    },
  },
  data() {
    return {
      xAxisData: [],
      seriesData: [],
      extraOption: {
        grid: {
          top: this.fitChartSize(35),
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        yAxis: [
          {
            name: '%',
            nameGap: this.fitChartSize(21),
            nameLocation: 'end',
            nameTextStyle: {
              color: '#fff',
              align: 'right',
              fontSize: this.fitChartSize(12),
              padding: [0, 6, 0, 0],
            },
            type: 'value',
            axisLabel: {
              color: '#c5c5c5',
              fontSize: this.fitChartSize(12),
              margin: this.fitChartSize(6),
            },
          },
        ],
        series: [
          {
            name: 'SOC',
            type: 'line',
            smooth: false,
            symbol: 'none',
            itemStyle: {
              color: 'rgba(101, 253, 228, 1)',
              shadowColor: 'rgba(101, 253, 228, 1)',
              shadowBlur: 8,
            },
            lineStyle: {
              color: 'rgba(101, 253, 228, 1)',
            },
            // 线条下方区域颜色
            areaStyle: {
              color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(101, 253, 228, 1)',
                },
                {
                  offset: 1,
                  color: 'rgba(101, 253, 228, 0)',
                },
              ]),
            },
          },
        ],
      },
    };
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.soc-line-chart {
  width: 100%;
  ::v-deep .pub-info-title {
    margin-bottom: 16px;
  }
  .chart-container {
    width: 471px;
    height: 230px;
    margin-bottom: 40px;
  }
}
</style>
